
import axios from '@/axios/axios2.js'
const BASE_URL = '/api/community/public'
const api = {
  location_list: `/api/v3/ex_bu_position/`,
  reserve_location: `/api/v3/ex_bu_position_reserve/`,
  location_order: `/api/v3/ex_bu_position_reserve/`,
  config_json: `/api/v3/setting/`
}

export const ExhibitinService = {
  getLocation(data) {
    return axios.get(api.location_list, { params: data }).then(res => {
      return Promise.resolve(res.data)
    })
  },
  getLocationOrder(data) {
    return axios.get(api.location_order, { params: data }).then(res => {
      return Promise.resolve(res.data)
    })
  },
  reserveLocation(data) {
    return axios.post(api.reserve_location, data).then(res => {
      return Promise.resolve(res.data)
    }).catch(err => {
      return Promise.reject(err)
    })
  },
  editLocationOrder(data) {
    return axios.patch(`${api.reserve_location}${data.id}/`, data).then(res => {
      return Promise.resolve(res.data)
    })
  },
  getConfig(data) {
    return axios.get(api.config_json, { params: data }).then(res => {
      return Promise.resolve(res.data)
    })
  }
}
export default ExhibitinService